export enum CHECKBOX_STATUS {
  INDETERMINATE = 'mixed',
  CHECKED = 'true',
  UNCHECKED = 'false',
}
